import { Box } from "@mui/material"
import React, { useEffect } from "react"
import { useAppContext, useAppDispatchContext } from "../../app/Context"
import { Agent } from "../../types/Agent"
import { StateAction } from "../../types/State"
import { JoinMeetingModal } from "../Modal/JoinMeeting"
import { UserLoginModal } from "../Modal/UserLogin"
import { AgentVideo } from "./AgentVideo"
import { Bottom } from "./Bottom"

interface AgentViewProps {
  agent: Agent
  permissionsGranted: boolean
  showContactForm: boolean
  setPermissionsGranted: (granted: boolean) => void
  onJoinCall: () => void
  joinMeetingModalProps?: { open: boolean; onClose: () => void }
  loginModalProps?: { open: boolean; onOpen?: () => void; onClose: () => void }
  agentExists: boolean
}

export const AgentView: React.FC<AgentViewProps> = ({
  agent,
  permissionsGranted,
  showContactForm,
  setPermissionsGranted,
  joinMeetingModalProps,
  loginModalProps,
  onJoinCall,
  agentExists,
}) => {
  const dispatch = useAppDispatchContext()
  const context = useAppContext()
  const { stream } = context || {}

  useEffect(() => {
    if (stream) {
      dispatch({ type: StateAction.setStream, payload: null })
    }
  }, [location.pathname, location.search])

  const handleGrantPermissions = (granted: boolean) => {
    if (granted) {
      setPermissionsGranted(granted)
      if (showContactForm && loginModalProps?.onOpen) {
        loginModalProps.onOpen()
      }
    }
  }

  const handleResetPermissions = () => {
    setPermissionsGranted(false)
    if (stream) {
      stream.getTracks().forEach((track) => track.stop())
      dispatch({ type: StateAction.setStream, payload: null })
    }
  }

  const handleCloseJoinModal = () => {
    handleResetPermissions()
    joinMeetingModalProps?.onClose()
  }

  const handleCloseLoginModal = () => {
    handleResetPermissions()
    loginModalProps?.onClose()
  }

  return (
    <Box sx={{ position: "absolute", inset: 0, overflow: "hidden" }}>
      <AgentVideo agent={agent} />

      {!permissionsGranted && (
        <Bottom
          agent={agent}
          handleGrantPermissions={handleGrantPermissions}
          agentExists={agentExists}
        />
      )}

      {joinMeetingModalProps && (
        <JoinMeetingModal
          open={joinMeetingModalProps.open}
          onClose={handleCloseJoinModal}
          onJoinCall={onJoinCall}
        />
      )}

      {showContactForm && (
        <UserLoginModal
          open={loginModalProps?.open}
          onClose={handleCloseLoginModal}
          onJoinCall={onJoinCall}
        />
      )}
    </Box>
  )
}
